<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M15.97 5.12C15.97 5.11 15.96 5.11 15.96 5.1C15.94 5.02 15.92 4.93 15.88 4.86C15.67 4.35 15.17 4 14.59 4C14.21 4 13.86 4.16 13.6 4.41L8 10V7.7H6V13.4H11.7V11.4H9.4L14 6.81V20H16V5.41C16 5.31 15.99 5.22 15.97 5.12Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
